import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=486cb723&scoped=true&"
import script from "./MainTabBar.vue?vue&type=script&lang=js&"
export * from "./MainTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486cb723",
  null
  
)

export default component.exports